import { render, staticRenderFns } from "./ReportDailySellsArea.vue?vue&type=template&id=24ffe852"
import script from "./ReportDailySellsArea.vue?vue&type=script&lang=js"
export * from "./ReportDailySellsArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports